import lang from '@/lang';

export const commonColumns = [
  {
    key: 'name',
    type: 'default',
    name: lang.t('client.name'),
    width: 250,
  },
  {
    key: 'code',
    type: 'default',
    name: lang.t('client.clientCode'),
    width: 150,
  },
];

export const extraColumns = [
  {
    key: 'productSetName',
    type: 'other',
    name: lang.t('shop.offer.offer'),
    icon: 'far fa-box',
    width: 200,
  },
  {
    key: 'day',
    type: 'other',
    name: lang.t('time.day'),
    icon: 'far fa-calendar-day',
    width: 60,
  },
  {
    key: 'month',
    type: 'other',
    name: lang.t('time.month'),
    icon: 'far fa-calendar-days',
    width: 80,
  },
  {
    key: 'created',
    type: 'other',
    name: lang.t('shop.created'),
    icon: 'far fa-clock',
    width: 120,
  },
  {
    key: 'status',
    type: 'other',
    name: lang.t('shop.orderStatus'),
    icon: 'far fa-box-circle-check',
    width: 140,
  },
  {
    key: 'paid',
    type: 'other',
    name: lang.t('shop.isPaid'),
    icon: 'far fa-circle-dollar',
    width: 100,
  },
  {
    key: 'delivered',
    type: 'other',
    name: lang.t('shop.delivered'),
    icon: 'far fa-hand-holding-box',
  },
  {
    key: 'count',
    type: 'other',
    name: lang.t('shop.listing.count'),
    icon: 'far fa-boxes-stacked',
  },
  {
    key: 'price',
    type: 'other',
    name: lang.t('shop.listing.price'),
    icon: 'far fa-money-bill-wave',
  },
  {
    key: 'discount',
    type: 'other',
    name: lang.t('shop.discountComment'),
    icon: 'far fa-comment-dollar',
  },
  {
    key: 'comment',
    type: 'other',
    name: lang.t('shop.comment'),
    icon: 'far fa-comment',
  },
  {
    key: 'timetable',
    type: 'other',
    name: lang.t('shop.timetable'),
    icon: 'far fa-calendar-grid-3',
    width: 200,
  },
  {
    key: 'vat',
    type: 'other',
    name: lang.t('shop.listing.vatCode'),
    icon: 'far fa-percent',
    width: 60,
  },
  {
    key: 'accountingCode',
    type: 'other',
    name: lang.t('shop.listing.accountingCode'),
    icon: 'far fa-message-code',
    width: 100,
  },
  {
    key: 'accountNumber',
    type: 'other',
    name: lang.t('payment.accountNumber'),
    icon: 'far fa-bank',
    width: 100,
  },
];

export const dictionary = [
  ...commonColumns,
  ...extraColumns,
].reduce((acc, curr) => {
  acc[curr.key] = curr;
  return acc;
}, {});

export default [
  ...commonColumns,
  ...extraColumns,
];
